<script lang="ts">
  import { cn } from '../../lib/utils/cn';

  type Variant = 'default' | 'success' | 'warning' | 'destructive' | 'team-us' | 'team-them';

  interface Props {
    label: string;
    variant?: Variant;
    class?: string;
  }

  let { label, variant = 'default', class: className = '' }: Props = $props();

  const variantClasses: Record<Variant, string> = {
    default:
      'bg-white/90 text-tx42-text border border-[var(--tx42-panel-border-subtle)] shadow-sm',
    success:
      'bg-[#d8eadf] text-[#1a5c38] border border-[#9bc4ad]',
    warning:
      'bg-[#f5e6c8] text-[#7c4a03] border border-[#d4a574]',
    destructive:
      'bg-[#f3d9d4] text-[#8b1f1f] border border-[#c97a7a]',
    'team-us': 'bg-[#d4e8dc] text-[#1a5c38] border border-[#7ab396]',
    'team-them': 'bg-[#e8d4dc] text-[#6b1f35] border border-[#b87a94]',
  };
</script>

<span
  class={cn(
    'inline-flex min-h-6 items-center rounded-[var(--tx42-radius-pill)] px-2.5 text-xs font-semibold uppercase tracking-wide',
    variantClasses[variant],
    className,
  )}
>
  {label}
</span>
